"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var form_group_with_select_1 = require("@reverbdotcom/commons/dist/components/form_group_with_select");
var tokenized_credit_card_fields_1 = require("./tokenized_credit_card_fields");
var CreateCreditCardForm = /** @class */ (function (_super) {
    tslib_1.__extends(CreateCreditCardForm, _super);
    function CreateCreditCardForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreateCreditCardForm.prototype.getCountryOptions = function () {
        return this.props.countries.map(function (country) {
            return {
                value: country.countryCode,
                text: country.name,
            };
        });
    };
    CreateCreditCardForm.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(form_group_with_input_1.default, { inputName: "billingCardCardholderName", label: I18n.t('discovery.creditCardForm.nameOnCard'), value: this.props.cardData.cardholderName, updateField: this.props.onCardDataUpdate, fieldName: "cardholderName", required: true }),
            React.createElement(tokenized_credit_card_fields_1.default, { onTokenizedFieldUpdate: this.props.onTokenizedFieldUpdate, onCardDataUpdate: this.props.onCardDataUpdate }),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
                    React.createElement(form_group_with_input_1.default, { label: I18n.t('discovery.creditCardForm.postalCode'), fieldName: "postalCode", inputName: "billingAddressPostalCode", value: this.props.billingCardAddress.postalCode, updateField: this.props.onBillingCardAddressUpdate, required: true })),
                React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
                    React.createElement(form_group_with_select_1.default, { label: I18n.t('discovery.creditCardForm.country'), fieldName: "countryCode", inputName: "billingAddressCountryCode", updateField: this.props.onBillingCardAddressUpdate, value: this.props.billingCardAddress.countryCode, required: true, options: this.getCountryOptions() }))),
            this.props.children));
    };
    return CreateCreditCardForm;
}(React.Component));
exports.default = CreateCreditCardForm;
//# sourceMappingURL=create_credit_card_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/create_credit_card_form.js
// module id = BBIB
// module chunks = 20 21